import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import * as S from './QuickStartSection.styles';
import useScreenSize from '@/hooks/useScreenSize';
import { useLiteWebView } from '@/hooks/useDefaultLiteWebView';

interface QuickStartSectionProps {
  onScrollToForm: () => void;
}

const VIMEO_ID_DESK = '1166012379';
const VIMEO_ID_MOBILE = '1166012613';

const getVimeoBgUrl = (id: string) => {
  const params = new URLSearchParams({
    background: '1',
    autoplay: '1',
    loop: '1',
    muted: '1',
    playsinline: '1',
    dnt: '1',
  });

  return `https://player.vimeo.com/video/${id}?${params.toString()}?app=1`;
};

export const QuickStartSection: React.FC<QuickStartSectionProps> = ({
  onScrollToForm,
}) => {
  const { t } = useTranslation();
  const { isWebView } = useBridgeState();
  const isLiteWebView = useLiteWebView();
  const { isSmall } = useScreenSize();
  const vimeoId = isSmall ? VIMEO_ID_MOBILE : VIMEO_ID_DESK;

  return (
    <S.QuickStartSection $topMargin={isWebView}>
      <S.VideoBackground aria-hidden="true">
        {isLiteWebView ? (
          <S.VideoPoster
            src="/images/business/poster.png"
            alt=""
            loading="lazy"
          />
        ) : (
          <S.VideoIframe
            src={getVimeoBgUrl(vimeoId)}
            title=""
            allow="autoplay; fullscreen; picture-in-picture"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        )}
      </S.VideoBackground>

      <S.QuickStartContainer>
        <S.QuickStartContent>
          <S.QuickStartTitle>{t('business.title')}</S.QuickStartTitle>
          <S.QuickStartDescription>
            {t('business.descr')}
          </S.QuickStartDescription>
          <S.QuickStartButtons>
            <S.QuickStartButtonPrimary
              type="button"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onScrollToForm();
              }}
            >
              {t('business.create_shop.button')}
            </S.QuickStartButtonPrimary>
            <S.QuickStartButtonSecondary
              type="button"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onScrollToForm();
              }}
            >
              {t('business.call')}
            </S.QuickStartButtonSecondary>
          </S.QuickStartButtons>
        </S.QuickStartContent>
      </S.QuickStartContainer>
    </S.QuickStartSection>
  );
};

QuickStartSection.displayName = 'QuickStartSection';
